import React, { useState, useEffect } from 'react'
import {Circles, Oval} from "react-loader-spinner";
import { goldColour, blueColour } from '../../pages/Home';
import VisDiv from './VisDiv';
import MusicPlayerScreen from '../../components/MusicPlayerScreen';

const Loading = ({progressBar = false, seconds = 60, quotes=[]}) => {

return <div>
    <Spinner message = "...Loading..."/>
    <VisDiv rules={progressBar}>
        <ProgressBar progressBar={progressBar} seconds={seconds} quotes={quotes}/>
    </VisDiv>
    </div>
}

export default Loading


export const Spinner = ({message}) => {
    return (

        <div style={{marginBottom: "20px"}} className="flex-center-column">
            <Oval color={blueColour} secondaryColor={goldColour} height={100} width={100} />
            <div style={{marginTop: "-93px"}}>
                 <img src="/favicon.png" width="80" height="80" alt="favicon-spinner" />
            </div>
           
        {/* <p>{message}</p> */}
        </div>
    );
}

export const ProgressBar = ({progressBar = false, seconds = 60, quotes = []}) => {
    const [progress, setProgress] = useState(0);
    
    useEffect(() => {
        const interval = setInterval(() => {
            setProgress(prevProgress => {
                if (prevProgress >= 99) {
                    clearInterval(interval);
                    return 99;
                }
                return prevProgress + (100 / (seconds * 10));
            });
        }, 100);
        
        return () => clearInterval(interval);
    }, [seconds]);
    
    return (
        <>
        <VisDiv rules={[progressBar]} style={{ 
            display: 'flex', 
            flexDirection: 'column', 
            alignItems: 'center', 
            width: '100%',
            marginBottom: "10px"
        }}>
            <div style={{ 
                width: '100%', 
                maxWidth: '300px', 
                height: '10px', 
                backgroundColor: blueColour,
                borderRadius: '5px',
                overflow: 'hidden',
                margin: '10px 0'
            }}>
                <div style={{ 
                    width: `${progress}%`, 
                    height: '100%', 
                    backgroundColor: goldColour,
                    transition: 'width 0.1s ease-in-out'
                }}></div>
            </div>
            <div style={{ fontSize: '12px', color: blueColour }}>
                {Math.round(progress)}%
            </div>

        </VisDiv>
        <VisDiv rules={[quotes?.length > 0]}>
            {/* Calculate current quote index based on progress */}
            <MusicPlayerScreen 
                isPlaying={true} 
                currentLyrics={quotes} 
                currentLyric={quotes[Math.min(Math.floor((progress / 100) * quotes.length), quotes.length - 1)]}
            />
        </VisDiv>
        </>
    );
}

export const rumiQuotes = [
    "What you seek is seeking you.",
    "Yesterday I was clever, so I wanted to change the world. Today I am wise, so I am changing myself.",
    "Raise your words, not voice. It is rain that grows flowers, not thunder.",
    "You are not a drop in the ocean. You are the entire ocean in a drop.",
    "The wound is the place where the Light enters you.",
    "Where there is ruin, there is hope for a treasure.",
    "Let yourself be silently drawn by the strange pull of what you really love.",
  ]